import { useSelector } from 'react-redux';

import { Text, TextButton } from '@zillow/constellation-10';

import type { RootState } from '../../../../../store/types';

const ContactLandlordSection = () => {
  const { name, email } = useSelector((state: RootState) => state.payments.renter.dashboard.landlordProfile);
  const landlordName = name || 'your landlord';

  if (!email) {
    return <Text className="fs-exclude">{landlordName}</Text>;
  }

  return (
    <TextButton asChild>
      <a className="fs-exclude" href={`mailto:${email}`}>
        Contact {landlordName}
      </a>
    </TextButton>
  );
};

export default ContactLandlordSection;
